module.exports = __webpack_public_path__ + "img/632.problem_lightning.bf795675.svg";